import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  background: ${(props) => props.theme.background};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.border};
  margin-bottom: 1rem;
`

export const CountBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem;
  background: ${(props) => {
    const percentage = props.$remaining / props.$limit
    if (percentage === 0) return props.theme.colors?.error || '#ef4444'
    if (percentage <= 0.33) return props.theme.colors?.warning || '#f59e0b'
    return props.theme.colors?.success || '#10b981'
  }};
  border-radius: 8px;
  color: white;

  .count {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
  }

  .label {
    font-size: 0.75rem;
    opacity: 0.9;
    margin-top: 0.25rem;
  }
`

export const WarningMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: ${(props) => (props.$isError ? 'rgba(239, 68, 68, 0.1)' : 'rgba(245, 158, 11, 0.1)')};
  border-left: 3px solid ${(props) => (props.$isError ? '#ef4444' : '#f59e0b')};
  border-radius: 4px;
  font-size: 0.875rem;
  color: ${(props) => props.theme.text};

  svg {
    flex-shrink: 0;
    color: ${(props) => (props.$isError ? '#ef4444' : '#f59e0b')};
  }
`

export const ResetTimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.textSecondary};

  svg {
    color: ${(props) => props.theme.textSecondary};
  }
`
